import { Route } from "@/routes/dashboard/settings/alert-management/alerts/$alertId/route.tsx";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs.tsx";
import { Link, useMatchRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { TabItem } from "@/components/custom/tabs/nav-tabs.tsx";

export const useAlertTabs = (): TabItem[] => {
  const { t } = useTranslation();

  const tabs: TabItem[] = [
    {
      title: t("overview"),
      path: "overview",
      requiredPermissions: ["alerts.view"],
      search: { __clear: true },
    },
  ];
  return tabs;
};

export const AlertTabs = () => {
  const tabs = useAlertTabs();
  const { alertId } = Route.useRouteContext();
  const matchRoute = useMatchRoute();
  const selected = tabs.find((tab) =>
    matchRoute({ from: Route.fullPath, to: tab.path, fuzzy: true }),
  )?.path;

  return (
    <Tabs value={selected}>
      <TabsList>
        {tabs.map((tab) => (
          <Link
            key={tab.path}
            from={Route.fullPath}
            to={tab.path}
            params={{ alertId: `${alertId}` }}
            search={tab.search}
          >
            <TabsTrigger value={tab.path ?? ""}>{tab.title}</TabsTrigger>
          </Link>
        ))}
      </TabsList>
    </Tabs>
  );
};
